<div *ngIf="permissions">
  <h4>Роли</h4>
  <table class="ngx-table__table--tiny ngx-table">
    <thead>
    <th>
      Роль
    </th>
    <th *ngFor="let basePermission of permissions.basePermission | keyvalue;">
      {{ basePermission.value }}
    </th>
    </thead>
    <tbody>
    <tr *ngFor="let managerRole of permissions.managersRoles; index as i;">
      <td class="p-2">
        {{ managerRole?.header }}
      </td>
      <td *ngFor="let basePermission of permissions.basePermission | keyvalue;" class="p-2">
        <nb-checkbox (checkedChange)="changeChecked(basePermission.key, managerRole.name,'role', $event)" [checked]="this.permissions.permissions[managerRole.name]?.includes(basePermission.key)"></nb-checkbox>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div *ngIf="permissions">
  <br>
  <h4>Пользователи</h4>
  <table class="ngx-table__table--tiny ngx-table">
    <thead>
    <th>
      Пользователь
    </th>
    <th *ngFor="let basePermission of permissions.basePermission | keyvalue;">
      {{ basePermission.value }}
    </th>
    </thead>
    <tbody>
    <tr *ngFor="let manager of permissions.managers | sort: {order: 'asc', key: 'lastName' }">
      <td class="p-2">
        {{ manager?.lastName }} {{ manager?.firstName }} ({{ manager?.login }})
      </td>
      <td *ngFor="let basePermission of permissions.basePermission | keyvalue;" class="p-2">
        <nb-checkbox (checkedChange)="changeChecked(basePermission.key, manager?.login,'user', $event)" [checked]="this.permissions.permissions[manager?.login]?.includes(basePermission.key)"></nb-checkbox>
      </td>
    </tr>

    </tbody>

  </table>
</div>


